<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal" tabindex="-1" id="сomplaintsModal" aria-labelledby="сomplaintsModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content shadow-none">
        <div class="modal-header">
          <h5 class="modal-title">Обращение</h5>
          <div @click="closeModal" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body">
          <input-field
            v-model="form.phone"
            id="form.phone"
            name="form.phone"
            :required="true"
            placeholder="Номер телефона"
            type="text"
            mb="5"
          />
          <input-field
            v-model="form.locationNumber"
            id="form.locationNumber"
            name="form.locationNumber"
            :required="true"
            placeholder="Номер Локации"
            type="text"
            mb="5"
          />
          <input-field
            v-model="form.connectorNumber"
            id="form.connectorNumber"
            name="form.connectorNumber"
            :required="true"
            placeholder="Номер Коннектора"
            type="text"
            mb="5"
          />
          <area-field
            v-model="form.problemDescription"
            id="form.problemDescription"
            name="form.problemDescription"
            class="h-auto h-125px mt-5"
            placeholder="Описание проблемы (свободный текст)"
            :required="true"
            mb="5"
          />
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" @click="closeModal" class="btn btn-light btn-sm" >Отмена</button>
          <button :disabled="!buttonDisabled || loading" type="button" @click="submitForm" class="btn btn-primary btn-sm"> {{ loading ? 'Отправка...' : 'Отправить' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notify }     from '@kyvg/vue3-notification'
import InputMaskField from '@/components/Fields/InputMaskField'
import SelectField    from '@/components/Fields/SelectField'
import InputField     from '@/components/Fields/InputField'
import AreaField      from '@/components/Fields/AreaField'
import axios          from 'axios'

export default {
  name: 'ComplaintsModal',
  components: {AreaField, InputMaskField, InputField, SelectField},
  data() {
    return {
      form: {
        phone: '',
        locationNumber: '',
        connectorNumber: '',
        problemDescription: '',
      },
      loading: false,
      buttonDisabled: false,
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('сomplaintsModal').addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) this.closeModal()
      });
    }, 10)
  },
  methods: {
    closeModal() {
      this.$emit('close', true)
      bootstrap.Modal.getInstance(document.getElementById('сomplaintsModal')).hide();
    },
    async submitForm() {
      this.loading = true
      const summary = `Обращение с локации №${this.form.locationNumber}, коннектор №${this.form.connectorNumber}`
      const description =
        `Номер телефона: ${this.form.phone},\n` +
        `Номер Локации: ${this.form.locationNumber},\n` +
        `Номер Коннектора: ${this.form.connectorNumber},\n` +
        `Описание проблемы: ${this.form.problemDescription}`

      axios.post(
        'https://tracker.energocharge.uz/api/issues',
        {project: { id: '0-6' }, summary, description},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer perm-bXVzYWJla292.NTgtMA==.DTnuApbvLx7RcfnbSEu611aHNCQMcz'
          }
        }
      )
        .then(() => {
          notify({duration: 7000, type: 'success', speed: 1000, title: 'Успешно', text: 'Обращение отправлено!',});
          this.$emit('close', true)
        })
        .catch(error => {
          notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: error.message,});
        })
        .finally(() => {this.loading = false})
    }
  },
  watch: {
    form: {
      deep: true,
      handler(value) {
        this.buttonDisabled = !!value.phone
          && !!value.locationNumber
          && !!value.connectorNumber
          && !!value.problemDescription
      }
    }
  }
}
</script>

<style scoped>

</style>